import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, AlertTriangle, MinusCircle } from "lucide-react";

export default function ReadinessPanel() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/hr/attendance/readiness").then(r => setData(r.data)).catch(() => setData({ ready: false, items: [] })); }, []);
  if (!data) return <div className="text-slate-400 text-sm py-6 text-center">Loading…</div>;
  return (
    <div data-testid="att-readiness-panel">
      <div className={`rounded-lg border p-3 mb-3 flex items-center gap-2 ${data.ready ? "border-emerald-200 bg-emerald-50 text-emerald-800" : "border-amber-300 bg-amber-50 text-amber-800"}`} data-testid="att-readiness-overall">
        {data.ready ? <CheckCircle2 className="w-5 h-5" /> : <AlertTriangle className="w-5 h-5" />}
        <span className="font-semibold">{data.ready ? "Attendance is ready to go live" : "Attendance setup incomplete"}</span>
      </div>
      <div className="space-y-2">
        {data.items.map(it => (
          <div key={it.key} className="rounded-lg border border-slate-200 bg-white p-3 flex items-center justify-between" data-testid={`att-readiness-${it.key}`}>
            <div>
              <div className="font-medium flex items-center gap-2">
                {!it.required ? <MinusCircle className="w-4 h-4 text-slate-300" /> : it.ok ? <CheckCircle2 className="w-4 h-4 text-emerald-600" /> : <AlertTriangle className="w-4 h-4 text-amber-600" />}
                {it.label}
              </div>
              <div className="text-xs text-slate-500 mt-0.5">{it.detail}</div>
            </div>
            <Badge variant="outline" className={!it.required ? "text-slate-400 border-slate-200" : it.ok ? "text-emerald-700 border-emerald-300" : "text-amber-700 border-amber-300"}>{it.status}</Badge>
          </div>
        ))}
      </div>
      <p className="text-xs text-slate-400 mt-3">Office QR only blocks go-live when a policy actually requires it. Office network verification is optional. Attendance stays disabled until the required items are configured.</p>
    </div>
  );
}
